export const DECIMAL_NON_ZERO_PATTERN = '^(?=.*[1-9])[0-9]{0,7}[.,]?[0-9]{1,2}$';
export const DECIMAL_NON_ZERO_REGEXP = new RegExp(DECIMAL_NON_ZERO_PATTERN);

export const DECIMAL_NEGATIVE_NON_ZERO_PATTERN = '^-?(?=.*[1-9])[0-9]{0,7}[.,]?[0-9]{1,2}$';

export const DECIMAL_PATTERN = '^[0-9]{0,7}[.,]?[0-9]{1,2}$';
export const DECIMAL_REGEXP = new RegExp(DECIMAL_PATTERN);

export const DECIMAL_PATTERN_EXTENDED = '^[0-9]{0,7}[.,]?[0-9]{1,5}$';
export const DECIMAL_REGEXP_EXTENDED = new RegExp(DECIMAL_PATTERN_EXTENDED);

export const PERCENTAGE_PATTERN = '^(100|[1-9]\\d?)$';
export const PERCENTAGE_REGEXP = new RegExp(PERCENTAGE_PATTERN);

export const DECIMAL_NEGATIVE_PATTERN = '^-?[0-9]{0,7}[.,]?[0-9]{1,2}$';
export const DECIMAL_NEGATIVE_PATTERN_EXTENDED = '^-?[0-9]{0,7}[.,]?[0-9]{1,4}$';
export const DECIMAL_NEGATIVE_REGEXP = new RegExp(DECIMAL_NEGATIVE_PATTERN);

export const DECIMAL_PATTERN_EXTENDED_MAX = '^-?[0-9]{0,7}[.,]?[0-9]{1,10}$';
export const DECIMAL_REGEXP_EXTENDED_MAX = new RegExp(DECIMAL_PATTERN_EXTENDED_MAX);
